import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ROLL_CALL_API_BASE_URL } from "../RollCallConfig/RollCallConfig";
import { Select } from "antd";
import Swal from "sweetalert2";
import { Trash } from "feather-icons-react/build/IconComponents";

const EditManualAttendance = ({ editObj }) => {
  const [editObjData, setEditObjData] = useState([]);
  const [shiftOption, setShiftOptions] = useState([]);
  const [swipes, setSwipes] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedShift, setSelectedShift] = useState(null);
  const [loading, setloading] = useState(false);

  const [editAttendanceData, setEditAttendanceData] = useState({
    SuperId: "",
    RegId: "",
    Reason: "",
    InStatus: "",
    OutStatus: "",
    DayInOutId: "",
    DateOfTransaction: "",
    ActualShiftId: "",
    DaySwipes: [
      {
        DaySwipesId: "",
        InTime: "",
        OutTime: "",
      },
    ],
  });

  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  console.log(swipes?.length);

  useEffect(() => {
    if (editObj) {
      setEditObjData(editObj);
    }
  }, [editObj]);

  useEffect(() => {
    setSelectedShift(editObjData?.ActualShiftId);
  }, [editObjData?.ActualShiftId]);

  const outStatusOptions = [
    { value: "P", label: "Present" },
    { value: "A", label: "Absent" },
    { value: "L", label: "Late" },
    { value: "D", label: "On Duty" },
    { value: "WO", label: "Week Off" },
  ];

  const inStatusOptions = [
    { value: "P", label: "Present" },
    { value: "A", label: "Absent" },
    { value: "L", label: "Late" },
    { value: "WO", label: "Week Off" },
  ];

  const handleShiftChange = (selectedOption) => {
    setSelectedShift(selectedOption);
    console.log("Selected Shift:", selectedOption);
    setEditAttendanceData((prevState) => ({
      ...prevState,
      ActualShiftId: selectedOption,
    }));
  };
  const extractTime = (timeStr) => {
    if (!timeStr) return "";
    if (timeStr.length === 5 && timeStr.includes(":")) {
      return timeStr;
    }
    const date = new Date(timeStr);
    return !isNaN(date) ? date.toISOString().substring(11, 16) : "";
  };

  useEffect(() => {
    if (tokenData && superIdData && selectedDate) {
      const fetchSwipes = async () => {
        try {
          const response = await fetch(
            `
                ${ROLL_CALL_API_BASE_URL}portal/Attendance/getSwipes?regid=${editObjData?.RegId}&superid=${superIdData}&date=${selectedDate}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            }
          );
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
          console.log("team swipes:", data);
          setSwipes(data.ResultData);
          console.log(data.ResultData);
        } catch (error) {
          console.log(error.message);
        }
      };

      fetchSwipes();
    }
  }, [tokenData, superIdData, selectedDate, editObjData?.RegId]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchShifts = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/shifts/getShiftsTypes?superid=${superIdData}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            }
          );
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          const data = await response.json();
          console.log("testing data:", data);

          setShiftOptions(data.ResultData);
        } catch (err) {
          console.log(err.message);
        }
      };

      fetchShifts();
    }
  }, [superIdData, tokenData]);

  const shiftOptions =
    shiftOption &&
    shiftOption.map((item) => ({
      value: item.shiftid,
      label: item.Name,
    }));

  const handleEditAttendance = () => {
    console.log(swipes?.DayInOutId);

    if (swipes?.DayInOutId) {
      const updatedSwipes = swipes?.DaySwipes.map((swipe) => ({
        DaySwipesId: swipe.DaySwipesId || "",
        InTime: swipe.InTime || "",
        OutTime: swipe.OutTime || "",
      }));
      console.log(editObjData?.SuperId);
      setEditAttendanceData({
        SuperId: editObjData?.SuperId,
        RegId: editObjData?.RegId,
        Reason: swipes.Reason,
        DayInOutId: swipes.DayInOutId,
        DateOfTransaction: swipes.DateOfTransaction,
        InStatus: swipes.InStatus,
        OutStatus: swipes.OutStatus,
        ActualShiftId: swipes.ActualShiftId,
        DaySwipes: updatedSwipes,
      });

      const shiftObj = shiftOptions.find(
        (s) => s.value === swipes.ActualShiftId
      );
      if (shiftObj) setSelectedShift(shiftObj);
    } else {
      console.log("No swipes present, skipping update.");
    }
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };
  const convertToISOTime = (timeStr) => {
    if (!timeStr || timeStr.length !== 5) return "";
    return new Date(`1970-01-01T${timeStr}:00Z`).toISOString();
  };

  useEffect(() => {
    if (editObjData?.DateOfTransaction) {
      setSelectedDate(formatDateForInput(editObjData.DateOfTransaction));
    }
  }, [editObjData]);

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setloading(true);
    if (superIdData && tokenData) {
      const { DaySwipes, ...inputdata } = editAttendanceData;

      const formattedDaySwipes = DaySwipes.map((swipe) => ({
        ...swipe,
        InTime:
          swipe.InTime?.length === 5
            ? convertToISOTime(swipe.InTime)
            : swipe.InTime,
        OutTime:
          swipe.OutTime?.length === 5
            ? convertToISOTime(swipe.OutTime)
            : swipe.OutTime,
        DaySwipesId: swipe.DaySwipesId || "0",
      }));

      const payload = {
        inputdata,
        DaySwipes: formattedDaySwipes,
      };

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/Attendance/updateManualAttendance`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(payload),
          }
        );

        console.log("Submitting payload:", payload);
        const responseData = await response.json();

        if (response.ok) {
          Swal.fire({
            title: "Success!",
            text: responseData.Message || "Attendance updated successfully.",
            icon: "success",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: `Failed to update attendance. Server responded with: ${
              responseData.Message || "Unknown error"
            }`,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: `An unexpected error occurred: ${
            error.message || "Unknown error"
          }`,
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        setloading(false);
      }
    }
  };

  const resetEditAttendanceData = () => {
    setEditAttendanceData({
      SuperId: "",
      RegId: "",
      Reason: "",
      InStatus: "",
      OutStatus: "",
      DayInOutId: "",
      DateOfTransaction: "",
      ActualShiftId: "",
      DaySwipes: [
        {
          DaySwipesId: "",
          InTime: "",
          OutTime: "",
        },
      ],
    });
  };

  useEffect(() => {
    const offcanvasEl = document.getElementById("offcanvasRightEditMA");

    const handleOffcanvasClose = () => {
      resetEditAttendanceData();
    };

    if (offcanvasEl) {
      offcanvasEl.addEventListener("hidden.bs.offcanvas", handleOffcanvasClose);
    }

    return () => {
      if (offcanvasEl) {
        offcanvasEl.removeEventListener(
          "hidden.bs.offcanvas",
          handleOffcanvasClose
        );
      }
    };
  }, []);

  return (
    <div>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasRightEditMA {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightEditMA {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightEditMA {
            width: 45% !important;
          }
        }
          
       @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightEditMA {
            width: 28% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightEditMA {
            width:22% !important;
          }
        }
        `}
      </style>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightEditMA"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Edit Attendance</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>{" "}
        <hr />
        <div className="offcanvas-body">
          <form onSubmit={handleEditSubmit}>
            <div className="row">
              <div className="col-5">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={editObjData?.UserName}
                  readOnly
                />
              </div>
              <div className="col-4">
                <label className="form-label">Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                />
              </div>
              <div className="col-3 d-flex align-items-end">
                <button
                  type="button"
                  className="btn btn-info"
                  onClick={handleEditAttendance}
                >
                  Get Swipes
                </button>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-4">
                <label className="form-label">In Status</label>
                <Select
                  style={{ width: 160 }}
                  placeholder="Choose Type"
                  value={editAttendanceData.InStatus}
                  onChange={(value) =>
                    setEditAttendanceData((prevState) => ({
                      ...prevState,

                      InStatus: value,
                    }))
                  }
                  options={inStatusOptions}
                />
              </div>
              <div className="col-4">
                <label className="form-label">Out Status</label>
                <Select
                  style={{ width: 160 }}
                  placeholder="Choose Type"
                  value={editAttendanceData.OutStatus}
                  onChange={(value) =>
                    setEditAttendanceData((prevState) => ({
                      ...prevState,
                      OutStatus: value,
                    }))
                  }
                  options={outStatusOptions}
                />
              </div>
              <div className="col-4">
                <label className="form-label">Actual Shift</label>
                <Select
                  placeholder="Choose Type"
                  value={selectedShift}
                  options={shiftOptions}
                  onChange={handleShiftChange}
                  style={{ width: 160 }}
                />
              </div>
            </div>
            {editAttendanceData.DaySwipes.length > 0 ? (
              <div className="d-flex flex-column">
                <div className="row mt-3">
                  <div className="col-5">
                    <label htmlFor={`in-time-0`} className="form-label">
                      In Time
                    </label>
                    <input
                      type="time"
                      className="form-control"
                      name={`InTime-0`}
                      value={
                        extractTime(editAttendanceData.DaySwipes[0].InTime) ||
                        ""
                      }
                      onChange={(e) =>
                        setEditAttendanceData((prevState) => {
                          const newDaySwipes = [...prevState.DaySwipes];
                          newDaySwipes[0] = {
                            ...newDaySwipes[0],
                            InTime: e.target.value,
                          };
                          return { ...prevState, DaySwipes: newDaySwipes };
                        })
                      }
                    />
                  </div>
                  <div className="col-5">
                    <label htmlFor={`out-time-0`} className="form-label">
                      Out Time
                    </label>
                    <input
                      type="time"
                      className="form-control"
                      name={`OutTime-0`}
                      value={
                        extractTime(editAttendanceData.DaySwipes[0].OutTime) ||
                        ""
                      }
                      onChange={(e) =>
                        setEditAttendanceData((prevState) => {
                          const newDaySwipes = [...prevState.DaySwipes];
                          newDaySwipes[0] = {
                            ...newDaySwipes[0],
                            OutTime: e.target.value,
                          };
                          return { ...prevState, DaySwipes: newDaySwipes };
                        })
                      }
                    />
                  </div>
                </div>

                {/* Iterate through additional breaks */}
                {editAttendanceData.DaySwipes.slice(1).map((swipe, index) => (
                  <div key={index + 1} className="row mt-3">
                    <div className="col-5">
                      <label
                        htmlFor={`in-time-${index + 1}`}
                        className="form-label"
                      >
                        In Time
                      </label>
                      <input
                        type="time"
                        className="form-control"
                        name={`InTime-${index + 1}`}
                        value={extractTime(swipe.InTime) || ""}
                        onChange={(e) =>
                          setEditAttendanceData((prevState) => {
                            const newDaySwipes = [...prevState.DaySwipes];
                            newDaySwipes[index + 1] = {
                              ...newDaySwipes[index + 1],
                              InTime: e.target.value,
                            };
                            return { ...prevState, DaySwipes: newDaySwipes };
                          })
                        }
                      />
                    </div>
                    <div className="col-5">
                      <label
                        htmlFor={`out-time-${index + 1}`}
                        className="form-label"
                      >
                        Out Time
                      </label>
                      <input
                        type="time"
                        className="form-control"
                        name={`OutTime-${index + 1}`}
                        value={extractTime(swipe.OutTime) || ""}
                        onChange={(e) =>
                          setEditAttendanceData((prevState) => {
                            const newDaySwipes = [...prevState.DaySwipes];
                            newDaySwipes[index + 1] = {
                              ...newDaySwipes[index + 1],
                              OutTime: e.target.value,
                            };
                            return { ...prevState, DaySwipes: newDaySwipes };
                          })
                        }
                      />
                    </div>

                    {swipe.DaySwipesId === "0" && (
                      <div className="col-2 d-flex justify-content-center align-items-end">
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() =>
                            setEditAttendanceData((prevState) => {
                              const newDaySwipes = prevState.DaySwipes.filter(
                                (_, i) => i !== index + 1
                              );
                              return {
                                ...prevState,
                                DaySwipes: newDaySwipes,
                              };
                            })
                          }
                        >
                          <Trash
                            className=" align-items-center"
                            size={24}
                          ></Trash>
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="row mt-3">
                <div className="col-6">
                  <label htmlFor="in-time" className="form-label">
                    In Time
                  </label>
                  <input
                    type="time"
                    className="form-control"
                    name="InTime"
                    value=""
                    onChange={(e) =>
                      setEditAttendanceData((prevState) => ({
                        ...prevState,
                        DaySwipes: [
                          {
                            DaySwipesId: "0",
                            InTime: e.target.value,
                            OutTime: "",
                          },
                        ],
                      }))
                    }
                  />
                </div>
                <div className="col-6">
                  <label htmlFor="out-time" className="form-label">
                    Out Time
                  </label>
                  <input
                    type="time"
                    className="form-control"
                    name="OutTime"
                    value=""
                    onChange={(e) =>
                      setEditAttendanceData((prevState) => ({
                        ...prevState,
                        DaySwipes: [
                          {
                            DaySwipesId: "0",
                            InTime: "",
                            OutTime: e.target.value,
                          },
                        ],
                      }))
                    }
                  />
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-12">
                <label className="form-label">Reason</label>
                <textarea
                  className="form-control"
                  value={editAttendanceData.Reason || ""}
                  onChange={(e) =>
                    setEditAttendanceData((prevState) => ({
                      ...prevState,
                      Reason: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
            <div className=" d-flex justify-content-end mt-3">
              <div className=" d-flex me-2 ">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() =>
                    setEditAttendanceData((prevState) => ({
                      ...prevState,
                      DaySwipes: [
                        ...prevState.DaySwipes,
                        { DaySwipesId: "0", InTime: "", OutTime: "" },
                      ],
                    }))
                  }
                >
                  Add Break
                </button>
              </div>
              <div className=" d-flex me-2 ">
                <button
                  type="submit"
                  className="btn btn-secondary"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                  onClick={resetEditAttendanceData}
                >
                  Cancel
                </button>
              </div>
              <div className=" d-flex ">
                <button className="btn btn-success">
                  {loading ? "Updating" : "Update"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

EditManualAttendance.propTypes = {
  editObj: PropTypes.object.isRequired,
};

export default EditManualAttendance;
